import { defineMessages } from 'react-intl';

export const subItemUsageRecordMessages = defineMessages({
    usageRecords: {
        id: 'usage-records',
        defaultMessage: 'Usage record',
    },
    records: {
        id: 'records',
        defaultMessage: 'Records',
    },
    record: {
        id: 'record',
        defaultMessage: 'Record',
    },
    billingPeriodEnd: {
        id: 'billing-period-end',
        defaultMessage: 'Billing period end',
    },
    billingPeriodStart: {
        id: 'billing-period-start',
        defaultMessage: 'Billing period start',
    },
    recordedAt: {
        id: 'usage-record-recorded-at',
        defaultMessage: 'Recorded at',
    },
    quantity: {
        id: 'usage-record-quantity',
        defaultMessage: 'Quantity',
    },
    addUsageRecordSubtitle: {
        id: 'add-usage-record-subtitle',
        defaultMessage: 'Record measured usage for a billing period of this item.',
    },
    billingPeriodHint: {
        id: 'usage-record-billing-period-hint',
        defaultMessage: 'The period this usage is billed in. It must match the period the item is charged for.',
    },
    createUsageRecordSuccess: {
        id: 'create-usage-record-success',
        defaultMessage: 'Usage record created',
    },
    createUsageRecordSuccessDescription: {
        id: 'create-usage-record-success-description',
        defaultMessage: 'The usage record has been successfully created.',
    },
    deleteUsageRecord: {
        id: 'delete-usage-record',
        defaultMessage: 'Delete usage record',
    },
    deleteUsageRecordSubtitle: {
        id: 'delete-usage-record-subtitle',
        defaultMessage: 'The billed usage for that period will be recalculated without it.',
    },
    confirmDeleteUsageRecord: {
        id: 'confirm-delete-usage-record',
        defaultMessage: 'Are you sure you want to delete this usage record?',
    },
    deleteUsageRecordSuccess: {
        id: 'delete-usage-record-success',
        defaultMessage: 'Usage record deleted',
    },
    deleteUsageRecordSuccessDescription: {
        id: 'delete-usage-record-success-description',
        defaultMessage: 'The usage record has been successfully deleted.',
    },
});
